import { EnrollmentLinkCreatorPage } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(
    EnrollmentLinkCreatorPage,
    '/enrollment-link-creator',
    [new RequiresAuthGuard(true)],
    {
      name: 'Enrollment Link Creator',
    }
  ),
]
